module.exports = __webpack_public_path__ + "static/img/r_013.719b62f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_013.jpg
// module id = 09BQ
// module chunks = 1